import React from "react"

import { createFileRoute, redirect } from "@tanstack/react-router"

import { CreateCustomerReferralDialog } from "@/components/customer-referrals/CreateCustomerReferralDialog"
import {
  CustomerReferralsTable,
  FallbackReferralsTable,
} from "@/components/customer-referrals/CustomerReferralsTable"
import { OutOfReferralsAlert } from "@/components/customer-referrals/OutOfReferralsAlert"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

export const Route = createFileRoute("/_dashboard/_customer/refer")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["users.view_userinvitation"])) {
      throw redirect({ to: "/" })
    }
  },
})

function RouteComponent() {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>My Referrals</CardTitle>
        <CreateCustomerReferralDialog />
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex w-full flex-col rounded-xl border-1 border-gray-200 p-8">
          <h1 className="text-2xl font-semibold text-balance">
            Earn $100 for Each Business You Refer!
          </h1>

          <h3 className="text-lg text-balance text-gray-700">
            You Get $100 - When they take capital through Boundless and complete
            their first funding round.
          </h3>

          <div className="mt-4 space-y-2">
            <h3 className="font-medium">Qualifying criteria</h3>
            <ul className="space-y-1 text-sm text-gray-700">
              <li>• Not currently a Boundless customer</li>
              <li>• Successfully takes capital through Boundless</li>
            </ul>
          </div>
        </div>

        <React.Suspense fallback={<FallbackReferralsTable />}>
          <OutOfReferralsAlert />
          <CustomerReferralsTable />
        </React.Suspense>
      </CardContent>
    </Card>
  )
}
